module.exports = __webpack_public_path__ + "static/media/execute_QuestionTheory.fe04a255.png";